module.exports = __webpack_public_path__ + "media/p_bpair_win.79f9cfef.mp3";